module.exports = __webpack_public_path__ + "static/media/BGPG2@2x.51ff1a35.png";